module.exports = __webpack_public_path__ + "img/dzp_title.d1cedf00.png";